import { createLocalStore } from 'stencil-store-storage';

const { state } = createLocalStore('exit-intent', {});

export default state;
